export default class selectCloseOnBlur {
    constructor() {
        return {
            restrict: 'A',
            controller: selectCloseOnBlurCtrl
        }
    }
}

class selectCloseOnBlurCtrl {
    constructor($scope, $element, $attrs, $timeout) {
        $timeout(() => {
            this.select = $($element).controller('uiSelect');

            if (this.select) {
                $(this.select.searchInput).on('blur', () => {
                    $timeout(() => {
                        this.select.close();
                    }, 300);
                });
            }
        });

        $scope.$on('$destroy', () => {
            if (this.select) {
                $(this.select.searchInput).off('blur');
            }
        });
    }
}
